const readEnv = (key, fallback = '') => {
  if (typeof import.meta !== 'undefined' && import.meta.env && Object.prototype.hasOwnProperty.call(import.meta.env, key)) {
    return import.meta.env[key] ?? fallback;
  }

  if (typeof window !== 'undefined' && window.__ENV__ && Object.prototype.hasOwnProperty.call(window.__ENV__, key)) {
    return window.__ENV__[key] ?? fallback;
  }

  return fallback;
};

const readBooleanEnv = (key, fallback = false) => {
  const value = readEnv(key, '').toString().trim().toLowerCase();
  if (!value) {
    return fallback;
  }
  return value === 'true' || value === '1' || value === 'yes';
};

export const env = {
  gaMeasurementId: readEnv('REACT_APP_GA_MEASUREMENT_ID', readEnv('NEXT_PUBLIC_GA_MEASUREMENT_ID', '')),
  llama: {
    useDirect: readBooleanEnv('REACT_APP_USE_LLAMA_DIRECT', false),
    stackUrl: readEnv('REACT_APP_LLAMA_STACK_URL', ''),
    model: readEnv('REACT_APP_LLAMA_MODEL', ''),
  },
  emailjs: {
    serviceId: readEnv('NEXT_PUBLIC_EMAILJS_SERVICE_ID', readEnv('EMAILJS_SERVICE_ID', '')),
    templateId: readEnv('NEXT_PUBLIC_EMAILJS_TEMPLATE_ID', readEnv('EMAILJS_TEMPLATE_ID', '')),
    publicKey: readEnv('NEXT_PUBLIC_EMAILJS_PUBLIC_KEY', readEnv('EMAILJS_PUBLIC_KEY', '')),
  },
  sheetdb: {
    registerUrl: readEnv('NEXT_PUBLIC_SHEETDB_API_URL_REGISTER', ''),
    enquiryUrl: readEnv('NEXT_PUBLIC_SHEETDB_API_URL_ENQUIRY', ''),
  },
  supabase: {
    url: readEnv('VITE_SUPABASE_URL', readEnv('NEXT_PUBLIC_SUPABASE_URL', '')),
    anonKey: readEnv('VITE_SUPABASE_ANON_KEY', readEnv('NEXT_PUBLIC_SUPABASE_ANON_KEY', '')),
    publishableKey: readEnv('VITE_SUPABASE_PUBLISHABLE_KEY', readEnv('NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY', '')),
  },
  chatApiUrl: readEnv('REACT_APP_CHAT_API_URL', ''),
};

export default env;
